module.exports = __webpack_public_path__ + "img/circle-white.5be15775.png";